import React, { useState, useEffect } from 'react';
import { Card, CardContent,InputLabel, Select, MenuItem, Checkbox,Typography, Grid, TextField, Button, FormControl,Box,FormHelperText, CircularProgress } from '@mui/material';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import {  IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useAuth } from '../../../../AuthProvider'; 
import { useFormikContext } from "formik";
import axios from "axios";
import Swal from "sweetalert2"; 
import { GlobalStyles } from "@mui/system";
import Modal from "@mui/material/Modal";


import { Table, TableBody,TableHead, TableCell, TableContainer, TableRow,
  Dialog, DialogTitle, DialogContent, DialogActions,ClickAwayListener,
   Paper } from "@mui/material";
  



const baseUrl=process.env.REACT_APP_API_BASE_URL
export default function AddNewClassSchedules() {

  
  
  // const { setValues } = useFormikContext();
  const navigate = useNavigate();
  const formik = useFormikContext();
  const setValues = formik?.setValues || (() => {}); // Fallback to empty function
  
  
  const [tableData, setTableData] = useState([]);

  const { userId, oId,role,pId ,board} = useAuth();

  const [teacherLoading, setTeacherLoading] = useState(false); 
  const [teachers, setTeachers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [tableLoading, settableLoading] = useState(true); 
  const [loading, setLoading] = useState(false);
  const [deleteloading, setDeleteLoading] = useState(false);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
const [selectedRow, setSelectedRow] = useState(null);



const [users, setUsers] = useState([]);
const [selectedUsers, setSelectedUsers] = useState('');
const isPrincipal = role?.startsWith("PRINCIPAL") || false;
const UserId = userId || selectedUsers;




const [sscClassOptions, setSscClassOptions] = useState([]);
const [sscSectionOptions, setSscSectionOptions] = useState([]);
const [sscSelectedClass, setSscSelectedClass] = useState();
const [sscSelectedSection, setSscSelectedSection] = useState();

// INTERMEDIATE states
const [interSectionOptions, setInterSectionOptions] = useState([]);
const [interSelectedClass, setInterSelectedClass] = useState("Inter-1st-Year");
const [interSelectedSection, setInterSelectedSection] = useState();
const [courseOptions, setCourseOptions] = useState([]);
const [selectedCourseType, setSelectedCourseType] = useState("");

const [sscClassSectionMap, setSscClassSectionMap] = useState({});

const [classSectionData, setClassSectionData] = useState(sscSectionOptions || interSectionOptions);
const [classOptions, setClassOptions] = useState(sscClassOptions || interSectionOptions);
const [sectionOptions, setSectionOptions] = useState([]);
const [selectedClass, setSelectedClass] = useState("");
const [selectedSection, setSelectedSection] = useState("");




const [periodOptions, setPeriodOptions] = useState([]);
const [timeSlotOptions, setTimeSlotOptions] = useState([]);
const [subjectOptions, setSubjectOptions] = useState([]);


  
  const [teacherId, setTeacherId] = useState(""); // Store selected Teacher
  const [day, setDay] = useState("Monday"); // Default to Monday



          const fetchUsers = async () => {
              try {
                  const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/SCHEDULE_MEETING/${oId}/${pId}`);
                  if (!response.ok) {
                      throw new Error('Failed to fetch users');
                  }
                  const data = await response.json();
                  setUsers(data);
                  if (data.length > 0) {
                    setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
                }
              } catch (error) {
                  console.error('Error fetching users:', error);
              }
          };
   useEffect(() => {
     if (isPrincipal) {
       fetchUsers();
     }
   }, []); // ✅ Only runs on mount 



// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
// const fetchClassRegistrationData = async () => {
//   try {
//     const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
//     const data = await response.json();

//     if (response.ok && Array.isArray(data)) {
//       // Group by class and merge section strings into unique values
//       const classSectionMap = {};

//       data.forEach(item => {
//         const className = item.classRegistration;
//         const sectionList = item.sections.split(",").map(s => s.trim());

//         if (!classSectionMap[className]) {
//           classSectionMap[className] = new Set();
//         }

//         sectionList.forEach(section => classSectionMap[className].add(section));
//       });

//       const classes = Object.keys(classSectionMap);
//       setSscClassOptions(classes); // Class dropdown options
//       setSscClassSectionMap(classSectionMap); // Save for section filtering later

//       // No default selection
//       setSscSelectedClass("");
//       setSscSelectedSection("");
//       setSscSectionOptions([]);
//     }
//   } catch (error) {
//     console.error("Error fetching SSC data:", error);
//   }
// };

const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach((item) => {
        const className = item.classRegistration;
        const sections = item.sections.split(",").map((s) => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sections.forEach((sec) => classSectionMap[className].add(sec));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes);
      setSscClassSectionMap(classSectionMap);

      if (classes.length) {
        const defaultClass = classes[0];
        const sectionArray = [...classSectionMap[defaultClass]];

        setSscSelectedClass(defaultClass);
        setSscSectionOptions(sectionArray);
        setSscSelectedSection(sectionArray[0] || ""); // ✅ Select first section
      } else {
        setSscSelectedClass("");
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};



// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      // if (!selectedCourseType) {
      //   setSelectedCourseType(data || "");
      // }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
      
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};





useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board,interSelectedClass, selectedCourseType, oId]);  // Removed selectedClass dependency here






// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);






  //select period api
  const fetchPeriodOptions = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/dynamic-time-table/period-numbers/${oId}/${pId}`); // Adjust endpoint as needed
      const data = await response.json();
  
      if (response.ok && Array.isArray(data)) {
        setPeriodOptions(data); // data should be an array of periods
      } else {
        setPeriodOptions([]);
      }
    } catch (error) {
      console.error("Error fetching period options:", error);
      setPeriodOptions([]);
    }
  };
  
  useEffect(() => {
    fetchPeriodOptions();
  }, [oId]);
  

  //select time api 
  const fetchTimeSlotOptions = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/dynamic-time-table/getAllTimeSlotsForScheduleTeacher/${oId}/${pId}`); // Adjust this endpoint as needed
      const data = await response.json();
  
      if (response.ok && Array.isArray(data)) {
        setTimeSlotOptions(data); // Example: [{ id: 1, slot: "08:00 AM - 09:00 AM" }, ...]
      } else {
        setTimeSlotOptions([]);
      }
    } catch (error) {
      console.error("Error fetching time slot options:", error);
      setTimeSlotOptions([]);
    }
  };
  
  useEffect(() => {
    fetchTimeSlotOptions();
  }, [oId]);

  // TeacherDropdown API
  useEffect(() => {
    const fetchTeachers = async () => {
      setTeacherLoading(true);
      try {
        const response = await fetch(`${baseUrl}/api/teacherTimeTable/getAllTeachers/${oId}/TEACHER/${pId}`);
        if(!response.ok){
          // throw new Error("Failed to fetch teachers");
          console.log('Failed to fetch teachers')
        } 
  
        const data = await response.json();
        console.log("Fetched Teachers:", data);
  
        // ✅ Ensure correct data mapping
        const extractedTeachers = data.map((teacher) => ({
          teacherId: teacher.teacherId,
          teacherFirstName: teacher.teacherFirstName || "Unknown",
          teacherLastName: teacher.teacherLastName || "",
        }));
  
        setTeachers(extractedTeachers);
         // ✅ Set the first teacher as default if available
      if (extractedTeachers.length > 0) {
        setTeacherId(extractedTeachers[0].teacherId);
      }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setTeacherLoading(false);
      }
    };
  
    fetchTeachers();
  }, [baseUrl,oId]);


      
 
        //  //select subject api 
        //  const fetchSubjectOptions = async () => {
        //   try {
        //     const selectedClass = sscSelectedClass || interSelectedClass;
        //     if (!selectedClass) return;
           
        //     // For INTERMEDIATE, ensure course type is also selected
        //     if (board === "INTERMEDIATE" && !selectedCourseType) return;
        
        //     let response;






        
        //     if (board === "SSC") {
        //       response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllSubjects/by-class/${pId}?classRegistration=${selectedClass}`);
        //     } else if (board === "INTERMEDIATE") {
        //       response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllSubjectsIntermediate/by-class/${pId}?classRegistration=${selectedClass}&course=${selectedCourseType}`);
        //     }
        
        //     if (!response) return;
        
        //     const data = await response.json();
        
        //     if (response.ok && Array.isArray(data) && typeof data[0] === 'string') {
        //       const subjectsArray = data[0].split(',').map((name, index) => ({
        //         id: index + 1,
        //         name: name.trim(),
        //       }));
        //       setSubjectOptions(subjectsArray);
        //     } else {
        //       setSubjectOptions([]);
        //     }
        //   } catch (error) {
        //     console.error("Error fetching subject options:", error);
        //     setSubjectOptions([]);
        //   }
        // };
        
        
        // useEffect(() => {
        //   if (oId && (sscSelectedClass || interSelectedClass)) {
        //     fetchSubjectOptions();
        //   }
        // }, [oId, sscSelectedClass, interSelectedClass,selectedCourseType]); // Add selectedClass dependencies
          


// --- Fetch Subject Options (reusable for both normal and edit mode) ---
const fetchSubjectOptions = async ({
  mode = "default",          // 'default' or 'edit'
} = {}) => {
  try {
    /* ---------- 1. Global guards (oId / pId must exist) ---------- */
    if (!oId || !pId) {
      setSubjectOptions([]);
      return;
    }

    /* ---------- 2. Board-specific guards ---------- */
    if (board === "SSC") {
      if (!sscSelectedClass) {
        setSubjectOptions([]);
        return;                       // no API call
      }
    } else if (board === "INTERMEDIATE") {
      if (!interSelectedClass || !selectedCourseType) {
        setSubjectOptions([]);
        return;                       // no API call
      }
    } else {
      setSubjectOptions([]);          // unknown board
      return;
    }

    /* ---------- 3. Build URL ---------- */
    let url = "";
    if (board === "SSC") {
      url = `${baseUrl}/api/dynamic-classReg/getAllSubjects/by-class/${pId}?classRegistration=${sscSelectedClass}`;
    } else if (board === "INTERMEDIATE") {
      // board === "INTERMEDIATE"
      url = `${baseUrl}/api/dynamic-classReg/getAllSubjectsIntermediate/by-class/${pId}?classRegistration=${interSelectedClass}&course=${selectedCourseType}`;
    }

    /* ---------- 4. Fetch ---------- */
    const response = await fetch(url);
    const data = await response.json();

    if (response.ok && Array.isArray(data) && typeof data[0] === "string") {
      const subjectsArray = data[0].split(",").map((name, idx) => ({
        id: idx + 1,
        name: name.trim(),
      }));
      setSubjectOptions(subjectsArray);
    } else {
      setSubjectOptions([]);
    }

    if (mode === "edit") {
      console.log("Subject options loaded for edit");
    }
  } catch (err) {
    console.error(`Error fetching subject options (${mode}):`, err);
    setSubjectOptions([]);
  }
};

/* ---------- effect ---------- */
useEffect(() => {
  fetchSubjectOptions();
}, [board, oId, pId, sscSelectedClass, interSelectedClass, selectedCourseType]);



   

 
  







  // Filter teachers based on search input
  const filteredTeachers = teachers.filter((teacher) =>
    `${teacher.id} ${teacher.name}`.toLowerCase().includes(searchTerm.toLowerCase())
  );



  
  // GetMethod For Table 
  const fetchTableData = async () => {
    if (!teacherId || !day) {
      settableLoading(false); // Stop loading if inputs are invalid
      return;
    }
    // if (!teacherId || !day) return; // Prevent API call if values are missing
  
    settableLoading(true);
    try {
      const response = await axios.get(
        `${baseUrl}/api/teacherTimeTable/getTeacherTimeTable/${oId}/${teacherId}/${day.toUpperCase()}`
      );
  
      console.log("API Response:", response.data); // ✅ Debug API Response
  
      // ✅ Adjusting the check based on your API response structure
      if (response.data && Array.isArray(response.data)) {
        setTableData(response.data); // ✅ Directly setting the array
      } else {
        console.warn("No data found:", response.data); // ✅ Log if empty
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setTableData([]);
    } finally {
      settableLoading(false);
    }
  };
  
  // ✅ Ensure API is called when dependencies change
  useEffect(() => {
    fetchTableData();
  }, [oId, baseUrl, teacherId, day]);
  
  const headerStyle = {
    borderRight: "1px solid #ddd",
    padding: "6px",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#fff9c4",
  };
  

    // Validation Schema
    const validationSchema = Yup.object().shape({
      teacherId: Yup.string().required("TeacherId is required"),
      // teacherName: Yup.string().required("Required"),
      dayNames: Yup.string().required("Day is required"),
      period: Yup.string().required("Period is required"),
      timeSlot: Yup.string().required("Time slot is required"),
      romanNumberClass: Yup.string().required("Class is required"),
      sections: Yup.string().required("Section is required"), // Ensuring section is required
      subject: Yup.string().required("Subject is required"),
    });
    


  const handleEditRow = (row) => {
    setSelectedRow(row); // Store the selected row data in state
    setIsEditModalOpen(true); // Open the edit modal
  };
  
  const handleUpdateRow = async () => {
    if (!selectedRow) {
      toast.error("No row selected for update.");
      return;
    }
  
    console.log("Selected Row Data before update:", selectedRow);
  
    try {
      const formData = new FormData();
  
      // Append non-null values to FormData
      Object.keys(selectedRow).forEach((key) => {
        if (selectedRow[key] !== null && selectedRow[key] !== undefined) {
          formData.append(key, selectedRow[key]);
        }
      });
  
      const response = await fetch(
        `${baseUrl}/api/teacherTimeTable/updateTeacherTimeTable/${selectedRow.id}/${oId}/${pId}`,
        {
          method: "PATCH",
          body: formData,
        }
      );
  
      let responseData;
      try {
        responseData = await response.text(); // Handle plain text response
      } catch (textError) {
        console.error("Error parsing response as text:", textError);
        responseData = "Unknown error occurred.";
      }
  
      if (!response.ok) {
        throw new Error(responseData); // Directly throw text error
      }
  
      toast.success("Row updated successfully!", { autoClose: 1000 });
  
      // Update table state
      setTableData((prevData) =>
        prevData.map((row) =>
          row.id === selectedRow.id ? { ...row, ...selectedRow } : row
        )
      );
  
      setSelectedRow(null); // Reset the state
      setIsEditModalOpen(false); // Close the modal
    } catch (error) {
      console.error("Error updating row:", error);
  
      // Show full response text in toast
      toast.error(error.message, { autoClose: 3000 });
    }
  };
  

// Function to handle delete action
const handleDeleteRow = async (id) => {
  if (!id) {
    toast.error("Invalid row. Please select a valid row to delete.");
    return;
  }

  // Show SweetAlert2 confirmation
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        console.log("Deleting row with ID:", id);
        // setDeleteLoading(true);

        // Send DELETE request to API
        const response = await fetch(
          `${baseUrl}/api/teacherTimeTable/deleteTeacherTimeTable/${id}/${oId}`,
          { method: "DELETE" }
        );

        if (!response.ok) {
          throw new Error("Failed to delete the row. Please try again.");
        }

        // Show success toast
        toast.success("Row deleted successfully!", { autoClose: 1000 });

        // Remove the row from state after successful deletion
        setTableData((prevData) => prevData.filter((row) => row.id !== id));
        
        // Show SweetAlert success message
        // Swal.fire("Deleted!", "Row has been deleted.", "success");
      } catch (error) {
        // console.error("Error deleting row:", error);
        toast.error(`Error deleting row: ${error.message}`);
      } 
      // finally {
      //   setDeleteLoading(false);
      // }
    }
  });
};

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minHeight: '100vh',
        paddingTop: '50px',
      }}
    >
      <Card
        style={{
          marginRight: "20px",
          marginLeft:'20px',
          marginTop:'20px',
          padding: "20px",
          backgroundColor: "#ffffff",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          width: "100%",
        }}
      >
        <CardContent>
                             <Box display="flex" alignItems="center" sx={{marginBottom:2, marginTop: -3, marginLeft: -3}}>
                              <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              Add New Teacher Schedule
                              </Typography>
                            </Box>

          
          {/* Formik Form */}
          <Formik
      initialValues={{
        teacherId: "",
        dayNames: "",
        period: "",
        timeSlot: "",
        romanNumberClass: "",
        course:"",
        sections: "",
        subject: "",
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        console.log("Submit is working");
      
        setLoading(true);
      
        try {
          // Create FormData object
          const formData = new FormData();

          
          Object.keys(values).forEach((key) => {
            formData.append(key, values[key]);
          });
      
          console.log("FormData entries:", Array.from(formData.entries())); // Debugging log
      
          const response = await fetch(`${baseUrl}/api/teacherTimeTable/saveTeacherTimeTable/multipleDays/${UserId}`, {
            method: "POST",                     
            body: formData, // Send as FormData
          });
      
          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to add period.${errorText}`);
          }
      
          const result = await response.json();
          toast.success("Period added successfully!");
          // setTableData([...tableData, values]);
          fetchTableData();
          resetForm();
        } catch (error) {
          toast.error(`Error adding period: ${error.message}`);
        } finally {
          setLoading(false);
          setSubmitting(false);
        }
      }}
      
    >
      {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
        <Form>
          <Grid container spacing={2} sx={{ 
    // border: "2px solid #ccc", 
    borderRadius: "8px", 
    padding: "16px",
    boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.1)", 
    // backgroundColor: "#f9f9f9" 
  }}>
            {/* Teacher Dropdown */}
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth size="small" error={touched.teacherId && Boolean(errors.teacherId)}>
                <InputLabel>Select Teacher</InputLabel>
                <Select
                  name="teacherId"
                  value={values.teacherId}
                  onChange={(e) => {
                    setFieldValue("teacherId", e.target.value);
                  }}
                  onBlur={handleBlur}
                  label="Select Teacher"
                >
                  {filteredTeachers.length > 0 ? (
                    filteredTeachers.map((teacher) => (
                      <MenuItem key={teacher.teacherId} value={teacher.teacherId}>
                        {teacher.teacherFirstName} {teacher.teacherLastName}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No teachers found</MenuItem>
                  )}
                </Select>
                {touched.teacherId && errors.teacherId && <FormHelperText>{errors.teacherId}</FormHelperText>}
              </FormControl>
            </Grid>

            {/* Day, Period, Time Slot, Class, Section, Subject */}
            {/* <Grid item xs={12} sm={3}>
  <FormControl fullWidth size="small" error={touched.dayName && Boolean(errors.dayName)}>
    <InputLabel>Select Day</InputLabel>
    <Select name="dayName" value={values.dayName} onChange={handleChange} onBlur={handleBlur} label="Select Day">
      <MenuItem value="Monday">Monday</MenuItem>
      <MenuItem value="Tuesday">Tuesday</MenuItem>
      <MenuItem value="Wednesday">Wednesday</MenuItem>
      <MenuItem value="Thursday">Thursday</MenuItem>
      <MenuItem value="Friday">Friday</MenuItem>
      <MenuItem value="Saturday">Saturday</MenuItem>
    </Select>
    {touched.dayName && errors.dayName && <FormHelperText>{errors.dayName}</FormHelperText>}
  </FormControl>
</Grid> */}


<Grid item xs={12} sm={3}>
  <FormControl
    fullWidth
    size="small"
    error={touched.dayNames && Boolean(errors.dayNames)}
  >
    <InputLabel>Select Day(s)</InputLabel>
    <Select
      name="dayNames"
      multiple
      value={values.dayNames ? values.dayNames.split(",") : []} // split CSV for Select value
      onChange={(event) => {
        let selected = event.target.value;

        // handle Select All
        if (selected.includes("all")) {
          const allDays = [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ];
          // If not all already selected, select all
          if (values.dayNames.split(",").length === allDays.length) {
            selected = []; // deselect all
          } else {
            selected = allDays; // select all
          }
        }

        setFieldValue("dayNames", selected.join(","));
      }}
      onBlur={handleBlur}
      label="Select Day(s)"
      renderValue={(selected) => selected.join(", ")}
    >
      <MenuItem value="all">
        <Checkbox
          checked={
            values.dayNames.split(",").filter(Boolean).length === 6
          }
          indeterminate={
            values.dayNames.split(",").filter(Boolean).length > 0 &&
            values.dayNames.split(",").filter(Boolean).length < 6
          }
        />
        <em>Select All</em>
      </MenuItem>

      {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map(
        (day) => (
          <MenuItem
            key={day}
            value={day}
            // disabled={day === "Friday"} // Example: disable Friday
          >
            <Checkbox
              checked={values.dayNames.split(",").includes(day)}
            />
            {day}
          </MenuItem>
        )
      )}
    </Select>
    {touched.dayNames && errors.dayNames && (
      <FormHelperText>{errors.dayNames}</FormHelperText>
    )}
  </FormControl>
</Grid>







{board === "SSC" && (
  <>
  <Grid item xs={12} sm={3}>
   <FormControl fullWidth size="small">
  <InputLabel id="class-select-label">Select Class</InputLabel>
  {/* <Select
    labelId="class-select-label"
    // value={sscSelectedClass}
    // onChange={(e) => setSscSelectedClass(e.target.value)}
    label="Select Class"

    name="romanNumberClass"
    value={values.romanNumberClass}
    // onChange={(e) => {
    //   const selected = e.target.value;
    //   handleChange(e); // updates Formik state
    //   setSscSelectedClass(selected); // optional: update your component state if used elsewhere
    // }}
     onChange={(e) => {
      const selected = e.target.value;

      // ✅ Formik handleChange
      handleChange(e);

      // ✅ Your custom logic
      setSscSelectedClass(selected);
      const sections = sscClassSectionMap[selected]
        ? Array.from(sscClassSectionMap[selected])
        : [];
      setSscSectionOptions(sections);
      setSscSelectedSection(
        sections.includes("Section-A") ? "Section-A" : sections[0] || ""
      );
    }}
    onBlur={handleBlur}
  >
    {sscClassOptions.length > 0 ? (
      sscClassOptions.map((cls) => (
        <MenuItem key={cls} value={cls}>
          {cls}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No classes available</MenuItem>
    )}
  </Select> */}
  <Select
  labelId="class-select-label"
  label="Select Class"
  name="romanNumberClass"
  value={values.romanNumberClass}
  onChange={(e) => {
    const selectedClass = e.target.value;

    // ✅ Update Formik state
    handleChange(e);

    // ✅ Update your local state
    setSscSelectedClass(selectedClass);

    // ✅ Get sections for that class
    const sections = sscClassSectionMap[selectedClass]
      ? Array.from(sscClassSectionMap[selectedClass])
      : [];

    setSscSectionOptions(sections);

    // ✅ Choose default section (prefer "Section-A")
    const defaultSection = sections.includes("Section-A")
      ? "Section-A"
      : sections[0] || "";

    setSscSelectedSection(defaultSection);

    // ✅ Update Formik `sections` value automatically
    setFieldValue("sections", defaultSection);
  }}
  onBlur={handleBlur}
>
  {sscClassOptions.length > 0 ? (
    sscClassOptions.map((cls) => (
      <MenuItem key={cls} value={cls}>
        {cls}
      </MenuItem>
    ))
  ) : (
    <MenuItem disabled>No classes available</MenuItem>
  )}
</Select>

</FormControl>
</Grid>

<Grid item xs={12} sm={3}>
<FormControl fullWidth size="small">
  <InputLabel id="section-select-label">Select Section</InputLabel>
  {/* <Select
    labelId="section-select-label"
    // value={sscSelectedSection}
    // onChange={(e) => setSscSelectedSection(e.target.value)}
    label="Select Section"

    name="sections"
        value={values.sections}
        onChange={(e) => {
          const selected = e.target.value;
          handleChange(e); // updates Formik state
          setSscSelectedSection(selected); // optional: update your component state if used elsewhere
        }}
        onBlur={handleBlur}
    
  >
    {sscSectionOptions.length > 0 ? (
      sscSectionOptions.map((section) => (
        <MenuItem key={section} value={section}>
          {section}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No sections available</MenuItem>
    )}
  </Select> */}
  <Select
  labelId="section-select-label"
  label="Select Section"
  name="sections"
  value={values.sections}
  onChange={(e) => {
    handleChange(e); 
    setSscSelectedSection(e.target.value);
  }}
  onBlur={handleBlur}
>
  {sscSectionOptions.length > 0 ? (
    sscSectionOptions.map((section) => (
      <MenuItem key={section} value={section}>
        {section}
      </MenuItem>
    ))
  ) : (
    <MenuItem disabled>No sections available</MenuItem>
  )}
</Select>

</FormControl>
</Grid>
  </>
)}


{board === "INTERMEDIATE" && (
  <>
  <Grid item xs={12} sm={3}>
    <FormControl fullWidth size="small" >
      <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
      <Select
        labelId="intermediate-class-select-label"
        label="Select Year"
        name="romanNumberClass"
        value={values.romanNumberClass}
        onChange={(e) => {
          const selected = e.target.value;
          handleChange(e); // updates Formik state
          setInterSelectedClass(selected); // optional: update your component state if used elsewhere
        }}
        onBlur={handleBlur}
      >
        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
      </Select>
    </FormControl>
    </Grid>


<Grid item xs={12} sm={3}>
    <FormControl fullWidth size="small">
  <InputLabel id="course-type-label">Select Course</InputLabel>
  <Select
    labelId="course-type-label"
    // value={selectedCourseType}

    name="course"
    value={values.course}
    onChange={(e) => {
      const selected = e.target.value;
      handleChange(e); // updates Formik state
      setSelectedCourseType(selected); // optional: update your component state if used elsewhere
    }}
    onBlur={handleBlur}

    // onChange={(e) => setSelectedCourseType(e.target.value)}
    label="Select Course"
  >
    {courseOptions.length > 0 ? (
      courseOptions.map((course, index) => (
        <MenuItem key={index} value={course}>
          {course}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No courses available</MenuItem>
    )}
  </Select>
</FormControl>
</Grid>

<Grid item xs={12} sm={3}>
    <FormControl fullWidth size="small">
  <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
  <Select
    labelId="intermediate-section-select-label"
    label="Select Section"

    name="sections"
        value={values.sections}
        onChange={(e) => {
          const selected = e.target.value;
          handleChange(e); // updates Formik state
          setInterSelectedSection(selected); // optional: update your component state if used elsewhere
        }}
        onBlur={handleBlur}

  >
    {interSectionOptions.length > 0 ? (
      interSectionOptions.map((section, index) => (
        <MenuItem key={index} value={section}>
          {section}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No sections for selected Year and Course</MenuItem>
    )}
  </Select>
</FormControl>
</Grid>

  </>
)}








<Grid item xs={12} sm={3}>
<FormControl fullWidth size="small" error={touched.period && Boolean(errors.period)}>
  <InputLabel>Select Period</InputLabel>
  <Select
    name="period"
    value={values.period}
    onChange={handleChange}
    onBlur={handleBlur}
    label="Select Period"
  >
    {periodOptions.map((period, index) => (
      <MenuItem key={index} value={period.periodNumber}>
           {`Period ${period.periodNumber}`}
      </MenuItem>
    ))}
  </Select>
  {touched.period && errors.period && (
    <FormHelperText>{errors.period}</FormHelperText>
  )}
</FormControl>


</Grid>

<Grid item xs={12} sm={3}>
<FormControl fullWidth size="small" error={touched.timeSlot && Boolean(errors.timeSlot)}>
  <InputLabel>Select Time</InputLabel>
  <Select
  name="timeSlot"
  value={values.timeSlot}
  onChange={handleChange}
  onBlur={handleBlur}
  label="Select Time"
>
{timeSlotOptions.map((slot) => (
   <MenuItem key={slot.id} value={`${slot}`}>
   {`${slot}`}
 </MenuItem>
  ))}
</Select>

  {touched.timeSlot && errors.timeSlot && (
    <FormHelperText>{errors.timeSlot}</FormHelperText>
  )}
</FormControl>

</Grid>



<Grid item xs={12} sm={3}>
<FormControl fullWidth size="small" error={touched.subject && Boolean(errors.subject)}>
  <InputLabel>Select Subject</InputLabel>
  <Select
    name="subject"
    value={values.subject}
    onChange={handleChange}
    onBlur={handleBlur}
    label="Select Subject"
  >
    {subjectOptions.map((subject) => (
  <MenuItem key={subject.id} value={subject.name}>
    {subject.name}
  </MenuItem>
    ))}
  </Select>
  {touched.subject && errors.subject && (
    <FormHelperText>{errors.subject}</FormHelperText>
  )}
</FormControl>


</Grid>



{/* Dropdown for Select User - Right Next to Date Selection */}
  {/* {isPrincipal && (
    <Grid item xs={12} sm={3} > 
      <FormControl fullWidth variant="outlined" size="small">
        <InputLabel>Select Schedule Admin</InputLabel>
        <Select
          value={selectedUsers}
          onChange={(e) => setSelectedUsers(e.target.value)}
          label="Select Schedule Admin"
          sx={{ height: "36px", display: "flex", alignItems: "center" }} // Matching height
        >
          {users.map((user) => (
            <MenuItem key={user.userId} value={user.userId}>
              {user.userId} - {user.firstName} {user.lastName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  )} */}



              {/* Submit Button */}
              <Grid item xs={12} sm={3} style={{ marginLeft: "auto" }} >
  <Button
    type="submit"
    variant="contained"
    fullWidth
    disabled={loading}
    sx={{ backgroundColor: "#6E69B0", "&:hover": { backgroundColor: "#58548E" } }} // Custom blue color
  >
    {loading ? <><CircularProgress size={20} sx={{ color: "white", marginRight: 1 }} /> Adding...</> : "Add Period"}
  </Button>
</Grid>


          </Grid>
         
        </Form>
      )}
    </Formik>




    <Grid container spacing={2} sx={{ 
    marginTop:"20px",
    borderRadius: "8px", 
    padding: "16px",
    boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.1)", 
    // backgroundColor: "#f9f9f9" 
  }}>

{/* Teacher & Day Dropdowns */}
<Grid item xs={12} sm={6} container spacing={2} sx={{ mt: -3 }}>
  {/* Teacher Dropdown */}
  <Grid item xs={6}>
    <FormControl fullWidth size="small">
      <InputLabel>Select Teacher</InputLabel>
      <Select
        value={teacherId}
        onChange={(e) => setTeacherId(e.target.value)}
         label="Select Teacher"
      >
        {filteredTeachers.length > 0 ? (
          filteredTeachers.map((teacher) => (
            <MenuItem key={teacher.teacherId} value={teacher.teacherId}>
              {teacher.teacherFirstName} {teacher.teacherLastName}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No teachers found</MenuItem>
        )}
      </Select>
    </FormControl>
  </Grid>

  {/* Day Dropdown */}
  <Grid item xs={6}>
    <FormControl fullWidth size="small">
      <InputLabel>Select Day</InputLabel>
      <Select
        name="dayName"
        value={day}
        onChange={(e) => setDay(e.target.value)}
         label="Select Day"
      >
        {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map((day) => (
          <MenuItem key={day} value={day}>
            {day}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
</Grid>

 <GlobalStyles
           styles={{
             '.custom-sidebar-scrollbar': {
               scrollbarWidth: 'thin', // For Firefox
               scrollbarColor: 'grey #e0e0e0',
             },
             '.custom-sidebar-scrollbar::-webkit-scrollbar': {
               width: '6px', // For WebKit-based browsers
             },
             '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
               background: '#f1f1f1', // Track color
             },
             '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
               backgroundColor: 'grey', // Thumb color
               borderRadius: '10px',
             },
             '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
               backgroundColor: '#555',
             },
           }}
         />   

  {/* Table Section */}
  <TableContainer
  component={Paper}
  sx={{
    borderRadius: 2,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    maxHeight: "350px",
    overflow: "auto",
    marginTop: "20px"
  }}
  className="custom-sidebar-scrollbar"
>
  <Table stickyHeader>
    <TableHead>
      <TableRow>
        <TableCell sx={headerStyle}>S.No</TableCell>
        <TableCell sx={headerStyle}>TeacherID</TableCell>
        <TableCell sx={headerStyle}>Weekday</TableCell>
        <TableCell sx={headerStyle}>Period</TableCell>
        <TableCell sx={headerStyle}>Time</TableCell>
        {board === "INTERMEDIATE" && (
        <TableCell sx={headerStyle}>Course</TableCell>
        )}
        <TableCell sx={headerStyle}>{board === "INTERMEDIATE" ? "Year" : "Class"}</TableCell>
        <TableCell sx={headerStyle}>Section</TableCell>
        <TableCell sx={headerStyle}>Subject</TableCell>
        <TableCell sx={headerStyle}>Action</TableCell>
      </TableRow>
    </TableHead>

    {tableLoading ? (
      <TableBody>
        <TableRow>
           <TableCell
                                colSpan={9}
                                style={{ textAlign: "center", padding: "20px" }}
                              >
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  alignItems="center"
                                >
                                  <CircularProgress />
                                  <Typography variant="body2" sx={{ mt: 1 }}>
                                    Loading Data...
                                  </Typography>
                                </Box>
                              </TableCell>
        </TableRow>
      </TableBody>
    ) : tableData.length === 0 ? (
      <TableBody>
        <TableRow>
          <TableCell colSpan={9} sx={{ textAlign: "center", padding: "20px" }}>
            No data found
          </TableCell>
        </TableRow>
      </TableBody>
    ) : (
      <TableBody>
        {tableData.map((row, index) => (
          <TableRow key={index} sx={{ backgroundColor: "white", "&:hover": { backgroundColor: "#f5f5f5" } }}>
            <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{index + 1}</TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.teacherId}</TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.dayName}</TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.period ? `Period ${row.period}` : "-"}</TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.timeSlot}</TableCell>
            {board === "INTERMEDIATE" && (
             <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.course}</TableCell>                    
             )}
            <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.romanNumberClass}</TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.sections}</TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>{row.subject}</TableCell>
            <TableCell sx={{ borderRight: "1px solid #ddd",padding: "6px",textAlign: "center",textAlign: "center" }}>
            <Button
  variant="contained"
  sx={{
    backgroundColor: "#1976d2",
    color: "white",
    marginRight: "5px",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  }}
  size="small"
  onClick={() => handleEditRow(row)} // Pass row data for editing
>
  Edit
</Button>


              <Button
  variant="contained"
  sx={{
    backgroundColor: "#f44336",
    color: "#fff",
    "&:hover": { backgroundColor: "#d32f2f" },
  }}
  size="small"
  onClick={() => handleDeleteRow(row.id)} // ✅ Use `row.id` as per API data
>
  Delete
</Button>


            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    )}
  </Table>
</TableContainer>
</Grid>
 {/* Dialog for Editing */}
 {isEditModalOpen && selectedRow && (
  <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 450,
        bgcolor: "background.paper",
        boxShadow: 24,
        padding: "10px 15px 15px 15px",
        borderRadius: 2,
      }}
    >
 <Typography
  variant="h5"
  gutterBottom
  sx={{ fontWeight: "bold", marginBottom: 2 }} // Bold text & margin below
>
  Edit Row
</Typography>


      <Grid container spacing={2}>
        {/* Row 1 */}
        <Grid item xs={6}>
  <FormControl
    fullWidth
    sx={{ backgroundColor: "#f0f0f0", borderRadius: "5px" }}
  >
    <TextField
      fullWidth size="small"
      label="Teacher ID"
      value={selectedRow.teacherId || ""}
      InputProps={{
        readOnly: true,
        sx: {
          backgroundColor: "#e0e0e0",
          color: "#666",
          borderRadius: "5px",
          pointerEvents: "none",
          "& .MuiInputBase-input": {
            color: "#666",
            cursor: "default",
          },
        },
      }}
    />
  </FormControl>
</Grid>

<Grid item xs={6}>
  <FormControl
    fullWidth
    sx={{ backgroundColor: "#f0f0f0", borderRadius: "5px" }}
  >
    <TextField
      fullWidth size="small"
      label= {board === "INTERMEDIATE" ? "Year" : "Class"}
      value={selectedRow.romanNumberClass || ""}
      InputProps={{
        readOnly: true,
        sx: {
          backgroundColor: "#e0e0e0",
          color: "#666",
          borderRadius: "5px",
          pointerEvents: "none",
          "& .MuiInputBase-input": {
            color: "#666",
            cursor: "default",
          },
        },
      }}
    />
  </FormControl>
</Grid>
{(board === "INTERMEDIATE") &&(
<Grid item xs={6}>
  <FormControl
    fullWidth
    sx={{ backgroundColor: "#f0f0f0", borderRadius: "5px" }}
  >
    <TextField
      fullWidth size="small"
      label="Course"
      value={selectedRow.course || ""}
      InputProps={{
        readOnly: true,
        sx: {
          backgroundColor: "#e0e0e0",
          color: "#666",
          borderRadius: "5px",
          pointerEvents: "none",
          "& .MuiInputBase-input": {
            color: "#666",
            cursor: "default",
          },
        },
      }}
    />
  </FormControl>
</Grid>
)}
<Grid item xs={6}>
  <FormControl
    fullWidth
    sx={{ backgroundColor: "#f0f0f0", borderRadius: "5px" }}
  >
    <TextField
      fullWidth size="small"
      label="Section"
      value={selectedRow.sections || ""}
      InputProps={{
        readOnly: true,
        sx: {
          backgroundColor: "#e0e0e0",
          color: "#666",
          borderRadius: "5px",
          pointerEvents: "none",
          "& .MuiInputBase-input": {
            color: "#666",
            cursor: "default",
          },
        },
      }}
    />
  </FormControl>
</Grid>

        <Grid item xs={6}>
  <FormControl fullWidth size="small">
    <InputLabel>Weekday</InputLabel>
    <Select
      name="dayName"
      value={selectedRow.dayName || ""}
      onChange={(e) =>
        setSelectedRow({ ...selectedRow, dayName: e.target.value })
      }
      
      
      label="Weekday"
    >
      {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map((day) => (
        <MenuItem key={day} value={day}>
          {day}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>


        {/* Row 2 */}
        <Grid item xs={6}>
  <FormControl fullWidth size="small">
    <InputLabel>Select Period</InputLabel>
    <Select
      value={selectedRow.period || ""}
      onChange={(e) =>
        setSelectedRow({ ...selectedRow, period: e.target.value })
      }
      label="Select Period"
    >
      {periodOptions.map((p, index) => (
        <MenuItem key={index} value={p.periodNumber}>
          {`Period ${p.periodNumber}`}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>

<Grid item xs={6}>
  <FormControl fullWidth size="small">
    <InputLabel>Select Time</InputLabel>
    <Select
      value={selectedRow.timeSlot || ""}
      onChange={(e) =>
        setSelectedRow({ ...selectedRow, timeSlot: e.target.value })
      }
      label="Select Time"
    >
      {timeSlotOptions.map((slot) => (
   <MenuItem key={slot.id} value={`${slot}`}>
   {`${slot}`}
 </MenuItem>
  ))}
    </Select>
  </FormControl>
</Grid>


        {/* Row 4 */}
        <Grid item xs={6}>
  <FormControl fullWidth size="small">
    <InputLabel>Select Subject</InputLabel>
    <Select
      value={selectedRow.subject || ""}
      onChange={(e) =>
        setSelectedRow({ ...selectedRow, subject: e.target.value })
      }
      label="Select Subject"
    >
     
{subjectOptions.map((subject) => (
  <MenuItem key={subject.id} value={subject.name}>
    {subject.name}
  </MenuItem>
    ))}
    </Select>
  </FormControl>
</Grid>

      </Grid>

      {/* Buttons */}
      <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>

      <Button
  variant="outlined"
   // Choose from "primary", "secondary", "success", "error", "warning", "info"
  onClick={() => setIsEditModalOpen(false)}
>
  Cancel
</Button>

  <Button
    variant="contained"
    sx={{
      backgroundColor: "#3C3972",
      color: "white",
      "&:hover": {
          backgroundColor: "#3C3972",
      },
      }}
    onClick={handleUpdateRow}
  >
    Save
  </Button>
</Box>

    </Box>
  </Modal>
)}



    
          <ToastContainer  position="top-right"  autoClose={2000} />
        </CardContent>
      </Card>
    </div>
  );
}